import {
  usePlotArea,
  useXAxisScale,
  useYAxisScale,
  useIsTooltipActive,
  useActiveTooltipLabel,
  useActiveTooltipCoordinate,
  ZIndexLayer,
} from 'recharts'
import { useTimelineStyles } from '~/crop/crop-schedule/hooks/use-timeline-styles'
import { formatDoyFull } from './gdd-chart-utils'

// Rendered directly inside ComposedChart (recharts v3 — no Customized wrapper needed).
// Handles only badge overlays; grid lines are handled by CartesianGrid with zIndex={150}.
export const GddChartDecorations = ({ currentDoy, nowLabel, lfd, ffd, yMax }) => {
  const { TimelineStyles } = useTimelineStyles()
  const plotArea = usePlotArea()
  const xScale = useXAxisScale()
  const yScale = useYAxisScale()
  const tooltipActive = useIsTooltipActive()
  const activeLabel = useActiveTooltipLabel()
  const activeCoord = useActiveTooltipCoordinate()

  if (!plotArea || !xScale || !yScale) return null
  const { x: left, y: plotTop, width } = plotArea
  const top = Math.max(plotTop, yScale(yMax))
  const bh = 16, br = 3

  const badge = (px, label, fillColor, textColor) => {
    const cx = Math.round(px)
    if (cx < left || cx > left + width) return null
    const bw = label.length > 4 ? 44 : 36
    const bx = Math.max(left, Math.min(left + width - bw, cx - bw / 2))
    return (
      <g key={`badge-${label}`}>
        <rect x={bx} y={top - bh} width={bw} height={bh} rx={br} fill={fillColor} />
        <text x={bx + bw / 2} y={top - bh / 2 + 3} textAnchor="middle" fill={textColor} fontSize={8} fontWeight={600}>{label}</text>
      </g>
    )
  }

  return (
    <ZIndexLayer zIndex={550}>
      <g style={{ pointerEvents: 'none' }}>
        {badge(xScale(currentDoy), nowLabel, TimelineStyles.now.fillColor, TimelineStyles.now.textColor)}
        {lfd != null && badge(xScale(lfd), 'LFD', TimelineStyles.frost.color, TimelineStyles.frost.textColor)}
        {ffd != null && badge(xScale(ffd), 'FFD', TimelineStyles.frost.color, TimelineStyles.frost.textColor)}
        {tooltipActive && activeCoord && badge(activeCoord.x, formatDoyFull(activeLabel), TimelineStyles.hover.fillColor, TimelineStyles.hover.textColor)}
      </g>
    </ZIndexLayer>
  )
}
